import http from "./http-common";
import { Auth } from 'aws-amplify';

async function getAutocomplete(current_value, category, signed_user, language="en") {
    let session;
    let headers = {};
    if (signed_user) {
      session = await Auth.currentSession();
      headers = {
        Authorization: 'Bearer ' + session?.accessToken?.jwtToken
      }
    }

    return http.get(
      `/autocomplete/?current_value=${current_value}&category=${category}&language=${language}`,
      {
        headers
      }
    );
}

const autocompleteService = {getAutocomplete}

export default autocompleteService;